module.exports = __webpack_public_path__ + "img/icon_mitigatingRisk.c631aa8b.svg";